import { createTheme } from "@mui/material";
import { useState } from "react"

const useTheme = () => {
  const [darkMode, setDarkMode] = useState(localStorage.getItem("darkMode") === "true" || false)

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  return {
    toggleDarkMode: () => {
      localStorage.setItem("darkMode", String(!darkMode))
      setDarkMode((prev) => !prev)
    },
    darkMode,
    theme
  }
}

export default useTheme